<div class="search-field" [class.show-results]="filterList && filterList.length > 0" [class.single-result]="!multiSelect">
    <div class="field-container">
        <label>{{ title }}</label>
        <ui-search-input-text #search (textChangeEvent)="onSearch($event)" [showClearBtn]="true"
            [tooltipText]="tooltipText" [disabled]="disabled" [selectedValue]="selectedValues"
            [placeholderText]="placeholderText" (onclear)="onClear()"></ui-search-input-text>
        <ui-search-result-list [list]="filterList" (selectChangeEvent)="onSelect($event)"></ui-search-result-list>
    </div>

    <div *ngIf="selected && multiSelect" class="selected-item">
        <span *ngIf="selected.length > 1">
            Valores Selecionados: {{ selectedValues }}
        </span>
        <span *ngIf="selected.length === 1">
            Valor Selecionado: {{ selectedValues }}
        </span>
    </div>
</div>
